/*
 * @Description: 订单管理
 * @Author: gao shuai
 * @Date: 2020-04-24 09:14:32
 * @LastEditTime: 2020-08-27 17:15:07
 * @LastEditors: gao shuai
 */

import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  /* -----------------------1.平台订单------------------------ */
  // 平台订单列表
  async platlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetTenantOrderPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取充值方式列表
  async productlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetProductList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取充值方式列表
  async throughlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetGalleryList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 导出平台订单游戏玩家
  async gamelist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/OutputTenantOrderList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取平台订单统计信息
  async platinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetTenantOrderStatistics',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 清空订单数据
  async clearorder(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/ClearOrders',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取订单详情
  async orderdetail(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetOrderDetail',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 退款
  async refundOrder(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/RefundOrder',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 扣单
  async deductionOrder(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/Chargeback',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------------2.代理订单------------------------ */
  // 代理列表
  async agentlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetAgentOrderPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 代理统计信息
  async agentinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetAgentOrderStatistics',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------------3.平台反单------------------------ */
  // 平台返单列表
  async backlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetChargebackOrderPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 返单
  async backorder(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/ReturnChargeback',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* -----------------------4.补发记录------------------------ */
  async ressueList(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageOrder/GetOrderReissueRecordsListAsync',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }
};
